<template>
  <div>
    <!-- /////////////// WRAPPER -->
    <div>
      <!-- //TITLE MOBILE -->
      <h1 class="mobile">Commerciaux</h1>
      <!-- //TITLE MOBILE -->

      <!-- //CONTENT -->
      <div class="block__commercials content__commercials">

        <!-- SIDEBAR -->
        <SidebarSearch class="mobile"/>
        <!-- SIDEBAR -->

        <!-- //TITLE DESKTOP -->
        <h1 class="desktop">Commerciaux</h1>
        <!-- //TITLE DESKTOP -->

        <!-- //BT FAVORITE -->
        <div class="desktop">
          <b-button class="bt btn-favoris mt-4 ">
            <div class="left" slot="start">
              <span>
                <font-awesome-icon :icon="['fas', 'star']" />
              </span>
              <p class="title">Favoris</p>
            </div>
            <div class="right" slot="end">
              <p class='label'>Aucun</p>
              <span>
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
              </span>            
            </div>
          </b-button>
        </div>
        <!-- //BT FAVORITE -->

        <!-- //ILLUSTRATION -->
        <div class="illustration">
          <img :src="content.illustration.src" alt="illustration">
          <div class="title">{{content.illustration.title}}</div>
          <div class="desc">{{content.illustration.desc}}</div>
        </div> 
        <!-- //ILLUSTRATION -->
        
        </div>
      <!-- //CONTENT -->
    </div>
    <!-- /////////////// WRAPPER -->



    

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">      
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition> 
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->

  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import SidebarSearch from '../../../module/sidebar/SidebarSearch'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'

export default {
  name:"commercialsHome",
    components:{
      SidebarSearch,
    }, 
    mixins: [
      ParentMixin,
      CatMixin      
    ],
    computed: {
      ...mapGetters([
        'getCommercialsHome',
        'getPageTransition',
      ])
    },
    data () {
      return {
        content:"",  
        isLoading:true,
      }
    },
    mounted(){
      this.scrollIt = this.getScroll;
    },
    created (){
      this.content = this.getCommercialsHome;
      setTimeout(() => {
          this.isLoading = false;
          // this.majData();
        },2000)

    },   
    methods : { 
    },
   watch: {
    getPageTransition() {
      this.transition = this.getPageTransition;
      this.scrollIt = this.getScroll;
      console.log('this.transition == ' + this.transition)
    },
  }     
};
</script>
